import type { RootState } from 'reducers';

const emptyArray: unknown[] = [];
const emptyObj: Record<string, unknown> = {};

const baseSelect =
  <T>(path: string, defaultValue: T) =>
    (state: RootState): T => {
      const keys = path.split('.');
      // Dynamic path traversal over the state tree; each hop is untyped by nature.
      let result: unknown = state;
      for (let i = 0; i < keys.length; i += 1) {
        result = (result as Record<string, unknown> | null | undefined)?.[keys[i]];
        if (result === undefined) return defaultValue;
      }
      return (result || defaultValue) as T;
    };

export const selectProductVersions = baseSelect('productVersion.productVersions', emptyArray);
export const selectSelectedRows = baseSelect('productVersion.selectedRows', emptyObj);
export const selectModal = baseSelect('productVersion.modal', emptyObj);
